module.exports = __webpack_public_path__ + "static/media/que-hacer-en-recoleta.3f6b64f5.md";